<template src="./ProfileForm.html"></template>
<style src="./ProfileForm.scss" lang="scss"></style>
<script>
import ProfilePersonalInformation from "@/components/ProfileForm/components/ProfilePersonalInformation.vue";
import ProfileEmails from "@/components/ProfileForm/components/ProfileEmails.vue";
import ProfileHeader from "@/components/ProfileForm/components/ProfileHeader.vue";
import ProfilePhoneNumbers from "@/components/ProfileForm/components/ProfilePhoneNumbers.vue";
import ProfileAddresses from "@/components/ProfileForm/components/ProfileAddresses.vue";
import ProfileAddressesNoFSM from "@/components/ProfileForm/components/ProfileAddressesNoFSM.vue";
import ProfilePersonalId from "@/components/ProfileForm/components/ProfilePersonalId.vue";
import ProfilePassword from "@/components/ProfileForm/components/ProfilePassword.vue";
import ProfileLocalization from "@/components/ProfileForm/components/ProfileLocalization.vue";
import ProfileAccountDeletion from "@/components/ProfileForm/components/ProfileAccountDeletion.vue";
import ProfileLinkedServices from "@/components/ProfileForm/components/ProfileLinkedServices.vue";
import ProfilePasskey from "@/components/ProfileForm/components/PasskeySection/components/ProfilePasskey.vue";
import ProfileNav from "@/components/ProfileForm/components/ProfileNav.vue";
import PolicyConsentsPopup from "@/components/PolicyConsentsPopup.vue";
import IntermediateRegistrationScreen from "@/components/IntermediateRegistrationScreen.vue";
import EsimSection from "@/components/ProfileForm/components/EsimSection.vue";
import VehiclesSection from "@/components/ProfileForm/components/VehiclesSection.vue";
import ConsentsSection from "@/components/ProfileForm/components/ConsentsSection.vue";
import DealersSection from "@/components/ProfileForm/components/DealersSection.vue";
import ProfilePictureUpload from "@/components/ProfileForm/components/ProfilePictureUpload";
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import { defineComponent } from 'vue';
import { defineAsyncComponent } from 'vue'


// import oneMoment from "../../../gcdm-one-library/gcdm-one-moment/src/bootstrap";

export default defineComponent({
  inject:['$c', '$t', 'brandClass', 'assetSource', '$toUpperCase'],
  name: "ProfileForm",
  mixins: [oneUtils.accessibilityMixin],
  
  components: {
    ProfilePasskey,
    ProfileAccountDeletion,
    ProfileLinkedServices,
    ProfilePersonalInformation,
    ProfileEmails,
    ProfileHeader,
    ProfilePhoneNumbers,
    ProfilePictureUpload,
    ProfileAddresses,
    ProfileAddressesNoFSM,
    ProfileNav,
    ProfilePersonalId,
    ProfilePassword,
    ProfileLocalization,
    PolicyConsentsPopup,
    EsimSection,
    VehiclesSection,
    ConsentsSection,
    DealersSection,
    IntermediateRegistrationScreen,
    OneTippy: defineAsyncComponent(() =>
      import('../../../gcdm-one-library/gcdm-one-tippy/src/OneTippy')
    )
},
  props: {},
  data: () => ({
    intermediateForm:null,
    policyConsentsToSend: {},
    enums: oneUtils.enums,
    sectionContent: null,
    error: null,
    policyToAccept: [],
    isEditDisabled: false,
    isLoading: false,
    isEditMode: false,
    showIntermediateRegistrationScreen: false,
    isEditModeForSection: {
      PPI: false,
      PPN: false,
      PE: false,
      PA: false,
    },
    salutationsFromServer: [],
    gendersFromServer: [],
    nationalitiesFromServer: [],
    passkeyEntries: [],
    passkeyCount: 0,
    passkeyServiceIsWorking: false
  }),
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    originalUser(){
      return this.$store.getters.getOriginalUser
    },
    policyDocuments() {
      const policyDocumentsFromConfig = this.$c("list_of_policy_documents");
      if (!policyDocumentsFromConfig) return [];
      return policyDocumentsFromConfig.filter(
        (p) => p.policy_document_name && p.type && p.type!='mrk_type'
      ).sort((a, b) => {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        });
    },
    policyNotCompliant: function(){
      const notCompliant = Object.keys(this.policyConsentsToSend).find(
        (key)=>{
          return this.policyConsentsToSend[key].consents.find(
            (c)=>{
              return c.variant=="MANDATORY" && c.consent=="REJECT";
            }
          );
        }
      );
      return notCompliant && notCompliant.length>=1;
    },
  },
  watch: {
    sectionContent: function (a) {
      this.$emit("sectionContent", a);
    },
     "$store.state.configurationParams": {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.language !== oldVal.language) {
          oneUtils.utils.showGlobalLoader();
          let promises = [];
          if(this.$c('enable_salutations_from_server')){
            promises.push(this.getSalutationsFromServerPromise());
          }
          if(this.$c('enable_genders_from_server')){
            promises.push(this.getGendersFromServerPromise());
          }
          promises.push(this.getNationalitiesFromServerPromise());
          Promise.allSettled(promises).then(values=>{
            oneUtils.utils.hideGlobalLoader();
          });
        }
      },
    },
  },
  async mounted() {
    const query = oneUtils.utils.getQueryParams();

    if(query.outcomeMessageFromWC) {
      this.sectionContent = oneUtils.enums.profilePages.ACCOUNT_DATA;
    }

    const awaitImport = await import('../../../gcdm-one-library/gcdm-one-moment/src/bootstrap');
    this.oneMoment = (awaitImport).default;
    const stickyElm = document.querySelector('.nav-bar.mobile')
    const observer = new IntersectionObserver(
      ([e]) => {
        e.target.classList.toggle('isSticky', e.intersectionRatio < 1);},
      {threshold: [1]}
    );
    stickyElm && observer.observe(stickyElm);

    this.error = this.$route ? this.$route.meta.customerError : null;
    if (this.error) {
      if (this.error === oneUtils.enums.errorReasons.SYSTEM_ERROR) {
        this.isEditDisabled = true;
        oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
      } else {
        console.log("Unhandled error", this.error);
      }
    }else{
      this.initializeProfile();
    }
  },
  methods: {
    initializeProfile(){
      const asyncInitialization = ()=>{
        // handle the silent data migration
        this.silentMigrationHandler();
        this.checkBuPa();
        if(this.oneMoment.isTodayYourBirthday(this.user.birthday)){
          oneUtils.utils.showBirthdayMessage();
        }
      }
        
      let promises = []
      if(this.$store.getters.configure("show_profile_policy_popup") && this.policyDocuments.length > 0){
        this.policyDocuments.forEach((policyConfig) => {
          promises.push(this.checkLatestPolicyPromise(policyConfig));
        });
      }

      if(this.$c('enable_salutations_from_server')){
        promises.push(this.getSalutationsFromServerPromise());
      }
      
      if(this.$c('enable_genders_from_server')) {
        promises.push(this.getGendersFromServerPromise());
      }

      if(this.$c("show_passkey_section")) {
        promises.push(this.getPasskeysPromise());
      }


      promises.push(this.getNationalitiesFromServerPromise());
      Promise.all(promises).then(()=>{
        oneUtils.utils.hideGlobalLoader();
        asyncInitialization();
      });

    },
    /**
     * handles the silent migration for the fsm
     */
     getPasskeysPromise() {
      return oneUtils.httpClient.getPasskeys(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
        .then((res) => {
          this.passkeyEntries = res.data.result ?? [];
          this.passkeyCount = res.data.resultCount;
          this.passkeyServiceIsWorking = true;
        }).catch((err) => {
          this.passkeyServiceIsWorking = false;
        })
    },
    silentMigrationHandler() {
      console.log('(transparentMigrationHandler) - user: ', this.user);
      this.silentSubmitUpdateForPreferredEmail();
    },

    /**
     * Set the BMW ID as preferred comunication email if not preferred
     */
    silentSubmitUpdateForPreferredEmail() {
      // Get the communication email object corresponding to the user's BMW ID
      const email = this.user.communications?.communicationEMails.find(e => e.value.toLowerCase() === this.user.email.toLowerCase());

      // If not found, or already preferred...
      if (!email || email.preferred) {

        // Return
        return;
      }

      // Else...

      // For each communication email...
      this.user.communications?.communicationEMails.forEach(communicationEmail => {

        // Set it as NOT preferred
        communicationEmail.preferred = false;
      });

      // Set it as preferred
      email.preferred = true;

      console.log(`(silentSubmitUpdateForPreferredEmail) update bmwid as preferred - user: `, email);
      
      // update profile
      oneUtils.httpClient.updateUser(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
        .then((data) => {
        })
        .catch((e) => {
        });
    },

    getSalutationsFromServerPromise(){
      return oneUtils.utils.getSalutationsFromServer().then((salutations)=>{
        console.log('setting salutations from server');
        this.salutationsFromServer=salutations;
      })
    },

    getGendersFromServerPromise() {
      return oneUtils.utils.getGendersFromServer().then((genders)=>{
        console.log('setting genders from server');
        this.gendersFromServer=genders;
      })
    },

    getNationalitiesFromServerPromise() {
      return oneUtils.utils.getNationalitiesFromServer().then((nationalities)=>{
        console.log('setting nationalities from server');
        this.nationalitiesFromServer=nationalities;
      });
    },



    // Start policy consents popup function

    onClose(){
      this.$emit('doLogout');
    },

    onPolicyUpdated(){
      this.checkBuPa();
      this.isEditDisabled = false;
      this.policyToAccept = [];
    },

    /**
     * This function shows the intermdiate registration if there are some user's data missing
     */
    checkBuPa(){
      if(!(this.user && Object.keys(this.user).length == 0)){
        if((!this.user.partnerCategory || !this.user.homeMarket || !this.user.correspondLanguageISO ) && !this.error){
          if(this.user.firstName && this.user.lastName){
            this.onSaveClickedInIntermediateRegistrationScreen(this.user.firstName, this.user.lastName, true)
          }else{
            this.isEditDisabled = true;
            this.showIntermediateRegistrationScreen=true;
          }
        }
        if((!this.user.firstName || !this.user.lastName) && !this.error){
          this.isEditDisabled = true;
          this.showIntermediateRegistrationScreen=true;
        }
      }
    },


    /**
     * This function update the polcy consents
     */
    updatePolicy(){
      oneUtils.utils.showGlobalLoader();
      let policyConsents = [];

      for (const policyDocument in this.policyConsentsToSend) {
        policyConsents = policyConsents.concat(this.policyConsentsToSend[policyDocument].consents);
      }
      const now = new Date().toISOString();
      policyConsents.map(p=>{delete p.variant; delete p.usage_id; p.consentDate=now; return p});
       oneUtils.httpClient
        .saveConsents(policyConsents, window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
        .then((data) => {
          oneUtils.httpClient.getConsents(this.$store.getters.getUser.gcid, window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then((res)=>{
            this.$store.dispatch("setupContactPolicyConsents", res.data);
            console.log("[ProfileForm] user refreshed after update policies");
          })
          .catch((err) => {
            console.log("[ProfileForm] error in user refresh after update policies");
          }).finally(() => {
            oneUtils.utils.hideGlobalLoader();
            this.isLoading = false;
            this.onPolicyUpdated();
          });
        })
        .catch((e) => {
          oneUtils.utils.hideGlobalLoader();
          this.isLoading = false;
          oneUtils.utils.showMessage("WARNING", this.$t("error_generic"));
        });
    },

    //valorize policy consents to send elemet value
    policyPopupFormCreated(policyInfo){
      console.log('CREATED');
      console.log('policyInfo: ',policyInfo);
      this.policyConsentsToSend[policyInfo.policy_document_name] = policyInfo;
    },

    //valorize policy consents to send elemet value
    policyPopupFormUpdated(policyInfo){
      console.log('UPDATED');
      console.log('policyInfo: ',policyInfo);
      this.policyConsentsToSend[policyInfo.policy_document_name].consents.map((p)=>{if(p.usage_id==policyInfo.usageId)p.consent=policyInfo.accepted});
      this.policyConsentsToSend[policyInfo.policy_document_name].dirty=true;
    },

    // End policy consents popup function


    // Start Intermediate registration popup function

    doLogout(){
      this.$emit('doLogout');
    },

    /**
     * This function store the user data per the intermediate registration
     * and calls back the update user function
     */

    onSaveClickedInIntermediateRegistrationScreen(name=null, surname=null, silent=false){
      if(!this.user.partnerCategory) this.user.partnerCategory="PERSON";
      if(!this.user.homeMarket) this.user.homeMarket=this.$store.state.configurationParams.country;
      if(!this.user.correspondLanguageISO) this.user.correspondLanguageISO=this.$store.state.configurationParams.language.toUpperCase();
      this.user.firstName = name || this.intermediateForm.firstName.$model;
      this.user.lastName = surname || this.intermediateForm.lastName.$model;
      //set communication email
      if(!this.user.communications){
        this.user.communications = {
          communicationEMails:[]
        };
      }else if(!this.user.communications?.communicationEMails){
        this.user.communications.communicationEMails = [];
      }
      let foundIt = false;
      for (const email of this.user.communications.communicationEMails) {
        if(email.value==this.user.email){
          foundIt=true;
          email.preferred = true;
        }else{
          email.preferred = false;
        }
      }
      if(!foundIt){
        this.user.communications.communicationEMails.push({
          "communicationStatus": 'PRIVATE',
          "communicationType": 'EMAIL',
          "preferred": true,
          "value": this.user.email,
        });
      }
      this.showIntermediateRegistrationScreen=false;
      this.updateUser(silent);
    },

    /**
     * This function update the user value and manage errors if present
     */
    updateUser(silent){
      this.isLoading=true;
      if (!silent) oneUtils.utils.showGlobalLoader();
      oneUtils.httpClient.updateUser(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then((data) => {
        this.onUpdateUserSuccess(data, silent);
      })
      .catch((err) => {
        this.onUpdateUserError(err, silent);
      });
    },
    onUpdateUserSuccess(data, silent) {
      this.isLoading=false;
      this.isEditDisabled = false;
      if (!silent) oneUtils.utils.hideGlobalLoader();
      !silent && oneUtils.utils.showMessage("SUCCESS", this.$t("profile_user_success"));
    },
    onUpdateUserError(err, silent) {
      if(silent){
        this.isEditDisabled = true;
      }
      this.isLoading=false;
      if (!silent) oneUtils.utils.hideGlobalLoader();
      // if(err.errorCode==oneUtils.enums.errorReasons.EMAIL_NOT_COMPLIANT ){
      //   oneUtils.utils.showMessage("ERROR", this.$t("profile_email_error_valid"));
      // }else{
      //   oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
      // }
    },
    // associate the intermediate form value
    intermediateRegistrationScreenFormChanged(form){ 
      this.intermediateForm=form;
    },

    /**
     * This function check if there are differences from the original user and
     * the value insered in the pre registration 
     */
    thereAreDifferences(){
      let userCopy = {...this.user};
      let originalUserCopy = {...this.$store.getters.getOriginalUser};
      //not include policy consents in the differences
      delete userCopy.contactPolicyConsents;
      delete originalUserCopy.contactPolicyConsents;
      return oneUtils.utils.thereAreDeepDifferences(userCopy, originalUserCopy);
    },

    submit(){
      this.updateUser(false);
    },


    // End Intermediate registration popup function


    checkEditMode(event) {
      this.isEditModeForSection[event.subSection] = event.value;
      this.isEditMode = !Object.values(this.isEditModeForSection).every((val) => !val);
    },

    autosave() {
      if(this.thereAreDifferences()) {
        this.updateUser(true);
      }
    },
    
    checkLatestPolicyPromise(policyConfig) {
      return oneUtils.httpClient
        .getPolicyDocument(policyConfig.policy_document_name)
        .then((latestPolicy) => {
          // is new consent needed - start
          const currentConsents =
          this.$store.getters.getUser.contactPolicyConsents || [];
          const isConsentsNeeded = !currentConsents.find(
            (p) =>
              p.country === latestPolicy.country &&
              p.policyId === latestPolicy.name &&
              p.majorVersion >= latestPolicy.majorVersion
          );
          // is new consent needed - end
          if (isConsentsNeeded) {
            this.policyToAccept.push(policyConfig);
            this.isEditDisabled = true;
          }
        })
        .catch((err) => {
        });
    },
  },
});
</script>
